import { WidgetComponentApi } from "./WidgetComponentApi";
let _widgetComponentApiInstance = null;
export function getWidgetComponentApiInstance() {
    if (!_widgetComponentApiInstance) {
        _widgetComponentApiInstance = new WidgetComponentApi();
    }
    return _widgetComponentApiInstance;
}
